<template>
  <div class="modal--addScopes">
    <div class="modalCustom__header">
      <h5 class="">{{ header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <!--           Content-->
      <div class="row">
        <div class="w-full">
          <label for="name" class="control-label">{{ $t('Role Name') }}</label>
          <fg-input
            type="text"
            id="name"
            :placeholder="$t('name')"
            v-model="name"
            addon-left-icon="ti ti-pencil"
            @input="name = $event"
          >
          </fg-input>
        </div>
      </div>

      <div class="row">
        <div class="w-full">
          <label for="description" class="control-label">{{ $t('description') }}</label>
          <fg-input
            type="text"
            id="description"
            :placeholder="$t('description')"
            v-model="description"
            addon-left-icon="ti ti-pencil"
            @input="description = $event"
          >
          </fg-input>
        </div>
      </div>

      <div class="row" v-if="scopes">
        <div class="w-full">
          <label for="scopes" class="control-label">{{ $t('Scopes') }}</label>
          <!-- Select Part -->
          <div class="pt-4">
            <multiselect
              v-model="selected_scopes"
              id="scopes"
              :options="scopes"
              :multiple="true"
              group-values="options"
              group-label="group"
              :group-select="true"
              placeholder="Type to search"
              track-by="scope_id"
              :close-on-select="false"
              label="name"
            >
              <template slot="option" slot-scope="props">
                <div class="option">
                  <span>{{ props.option.$groupLabel }}</span>
                  <div class="flex flex-column">
                    <span class="option__title">{{ props.option.name }}</span>
                    <span class="option__small">{{ props.option.description }}</span>
                  </div>
                </div>
              </template>
              <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </multiselect>
          </div>
          <!-- End Select Part -->
          <!--          <multiselect v-model="selected_scopes" :options="scopes"-->
          <!--                       track-by="scope_id"-->
          <!--                       label="name"-->
          <!--                       id="scopes"-->
          <!--                       :searchable="true"-->
          <!--                       :multiple="true"-->
          <!--                       :close-on-select="false"-->
          <!--                       :show-labels="false"-->
          <!--                       :placeholder="$t('please_chose_the_scopes')">-->

          <!--            <template slot="option" slot-scope="props">-->
          <!--              <div class="option">-->
          <!--                <div class="flex flex-column">-->
          <!--                  <span class="option__title">{{ props.option.name }}</span>-->
          <!--                  <span class="option__small">{{ props.option.description }}</span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->

          <!--          </multiselect>-->
        </div>
      </div>
    </div>

    <div class="modalCustom__footer">
      <!--            buttons                   -->
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div>
        <p-button type="success" round @click.native.prevent="createRole">
          {{ $t('save') }}
        </p-button>
      </div>
    </div>
  </div>
</template>

<script>
import CreateNewButton from '../buttons/CreateNewButton';
import CancelButton from '../buttons/CancelButton';
import SaveButton from '../buttons/SaveButton';
import SmallInput from '../Inputs/SmallInput';
import SvgName from '../svg/SvgName';
import SvgDescription from '../svg/SvgDescription';
import Multiselect from 'vue-multiselect';
import axiosAuth from '../../axiosMain';
import GroupScopesController from '@/controllers/Scopes/GroupScopesController';
export default {
  name: 'CreateRoleModal',
  components: { SvgDescription, SvgName, SmallInput, SaveButton, CancelButton, CreateNewButton, Multiselect },
  props: {
    data: {
      type: Object,
      header: {
        type: String,
      },
    },
  },
  data: function () {
    return {
      open: false,
      name: '',
      description: '',
      scopes: this.$store.getters.userScopesCollection,
      selected_scopes: null,
      header: this.$t('create_new_role'),
    };
  },
  mounted: function () {
    this.setHeader();
    this.groupScopes();
  },
  methods: {
    closeModal: function () {
      this.selected_scopes = null;
      this.$emit('close');
    },
    createRole: function () {
      this.selected_scopes.forEach((scope) => {
        scope['companies_ids'] = [this.$store.getters.user.company.data.company_id];
      });
      axiosAuth
        .post(
          '/roles',
          {
            name: this.name,
            description: this.description,
            is_custom: 1,
            scopes: this.selected_scopes,
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.closeModal();
          this.$emit('submit', response.data);
          this.$notify({
            type: 'success',
            title: this.$t('Succesfull'),
            text: this.$t('The_role_was_assigned'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
    setHeader: function () {
      if (this.data.header !== undefined && this.data.header !== null) this.header = this.data.header;
    },
    groupScopes() {
      this.scopes = GroupScopesController.groupScopes(this.scopes);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped></style>
